const config = (window.PFS && window.PFS.config) || {};

export const carouselConfig = config.carousel || {};

export const isDev = config.isDev || {};

export const searchConfig = PFS.config.search || {};

export default config;
